module.exports = __webpack_public_path__ + "img/cancel_button@2x.6b839631.png";